import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=2b7ee6fa&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=ts&"
export * from "./Integrations.vue?vue&type=script&lang=ts&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=2b7ee6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ee6fa",
  null
  
)

export default component.exports